import { useQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import { GET_COMPLICACIONES_COMBO, parseComplicaciones } from "../../../data/graphQL/queries/MisVisitas/getComplicacionByIdTipoModulo";


export const useGetComplicacionesCombo = (idTipoModulo) => {
  const [complicacionesCombo, setComplicacionesCombo] = useState([]);

  const { data: dataComplicaciones } = useQuery(GET_COMPLICACIONES_COMBO, {
    skip: !Number.isInteger(idTipoModulo),
    variables: { idTipoModulo },
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataComplicaciones) return;
    const adaptedComplicaciones = parseComplicaciones(dataComplicaciones?.complicacionByIdTipoModulo || []);
    setComplicacionesCombo(adaptedComplicaciones);
  }, [dataComplicaciones]);

  return complicacionesCombo;
};